import(/* webpackMode: "eager", webpackExports: ["WeeklyMenu"] */ "/vercel/path0/components/meals/weekly-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsultButton"] */ "/vercel/path0/components/site/consult-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
